function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.80468 3.13807C10.065 2.87772 10.065 2.45561 9.80468 2.19526C9.54433 1.93491 9.12222 1.93491 8.86188 2.19526L6 5.05716L3.13812 2.19526C2.87778 1.93491 2.45567 1.93491 2.19532 2.19526C1.93497 2.45561 1.93497 2.87772 2.19532 3.13807L5.0572 5.99997L2.19526 8.86193C1.93491 9.12228 1.93491 9.54439 2.19526 9.80474C2.45561 10.0651 2.87771 10.0651 3.13806 9.80474L6 6.94278L8.86194 9.80474C9.12229 10.0651 9.54439 10.0651 9.80474 9.80474C10.0651 9.54439 10.0651 9.12228 9.80474 8.86193L6.9428 5.99997L9.80468 3.13807Z"
  }));
};

export default SvgComponent;